import { useTicketWrapper } from 'features/ShopWrapperLayout/TicketWrapperContext';
import { IGiftCardV3PaymentValue } from 'features/cashier/services/types/giftCard';
import ConfirmTipTicket, { useConfirmTipTicketRef } from 'features/payment/components/ConfirmTipTicket';
import PaymentLoading, { IPaymentLoadingRef } from 'features/payment/components/PaymentLoading';
import { useModalChooseNextPaymentRef } from 'features/payment/pages/PaymentPage/CashierSide/components/GiftCard/ModalChooseNextPayment';
import ModalPaymentGiftCard, { ModalPaymentGiftCardRefs } from 'features/payment/pages/PaymentPage/CashierSide/components/GiftCard/ModalPaymentGiftCard';
import paymentApis from 'features/payment/services/apis';
import { PAYMENT_TYPE } from 'features/payment/services/constants';
import { IBodyAPIPayment } from 'features/payment/services/types/api';
import { useSocketContext } from 'hooks/useSocket';
import { set, sumBy } from 'lodash';
import { useRef, useState, useTransition } from 'react';
import { IResponseDataBody } from 'services/response';
import CashierActionButton from '../CashierActionBtn';
import useGetDetailTicket from '../useGetDetailTicket';
import useUpdateTicket from '../useUpdateTicket';
import { cashierBtnMultiPayV3 } from './ButtonMultiPayV3';
import useCheckValidPoint from 'features/cashier/components/useCheckValidPoint';
import { consentFormRef } from '../CenterMainBody/ModalConsentForm';
type Props = {
  v2?: boolean;
};
const ButtonGiftCard = ({ v2 }: Props) => {
  const updateTicket = useUpdateTicket();
  const [openCheckValidPoint, contextCheckValidPoint] = useCheckValidPoint();
  const ticketContext = useTicketWrapper();
  const socketContext = useSocketContext();
  const completedTicketModalRef = useConfirmTipTicketRef();
  const modalChooseNextPaymentRef = useModalChooseNextPaymentRef();

  const loadingRef = useRef<IPaymentLoadingRef>(null);
  const refModal = useRef<ModalPaymentGiftCardRefs>(null);

  const [detailTicket, getDetailTicket] = useGetDetailTicket();

  const [visible, setVisible] = useState(false);

  const [giftCardPayments, setGiftCardPayments] = useState<IGiftCardV3PaymentValue[]>([]);

  const [, startTransition] = useTransition();

  const onDeleteItem = (item: IGiftCardV3PaymentValue) => {
    const exist = giftCardPayments.findIndex(o => o.giftCardId === item.giftCardId);
    if (exist == -1) return;
    const temp = [...giftCardPayments];
    temp.splice(exist, 1);
    setGiftCardPayments(temp);
  };

  const onLoyalty = async () => {
    try {
      const rest: { billId: string } | null = await updateTicket();
      if (!rest) return;

      const billId = rest.billId;
      const detail = await getDetailTicket(billId);
      if (!detail) return;
      if (detail.customerId && detail.enableSignedConsentForm && !(await consentFormRef.current?.open(detail?.customerId))) {
        return;
      }
      openCheckValidPoint(detail, () => {
        socketContext.switchCusPayment(billId);
        startTransition(() => {
          setVisible(true);
          setGiftCardPayments([]);
        });
        setTimeout(() => refModal.current?.setAmount(0), 100);
      });
    } catch (error) { }
  };

  const handleRedeem = async (val: IGiftCardV3PaymentValue) => {
    if (!detailTicket) return;
    const exist = giftCardPayments.findIndex(o => o.giftCardId === val.giftCardId);
    const temp = [...giftCardPayments];
    if (exist === -1) {
      temp.push(val);
    } else {
      set(temp, exist, val);
    }
    setGiftCardPayments(temp);
    const amount = sumBy(temp, o => o.amount);
    if (amount < (detailTicket.total)) {
      modalChooseNextPaymentRef?.current?.open((type) => {
        if (type === 'GIFT_CARD') {
          refModal.current?.reset(true);
          return;
        }
        onContinueWithMultiple(temp);
      });
      return;
    }
    onPayment(temp);
  };

  const onContinueWithMultiple = async (giftCards: IGiftCardV3PaymentValue[]) => {
    if (!detailTicket?.billId) return;
    cashierBtnMultiPayV3.current?.continueGiftCardPayWithMultiPay(detailTicket.billId, giftCards);
  };

  const onPayment = async (giftCards: IGiftCardV3PaymentValue[]) => {
    if (!detailTicket?.billId) return;
    const body: IBodyAPIPayment = {
      billId: detailTicket.billId,
      paymentInfo: giftCards.map(o => ({
        paymentType: PAYMENT_TYPE.GIFT_CARD,
        amount: o.amount,
        giftCardId: o.giftCardId,
      }))
    };

    loadingRef.current?.setVisible(true);
    try {
      const res: IResponseDataBody<true> = await paymentApis.payment(body);
      if (res?.data?.data) {
        loadingRef.current?.setVisible(false);
        socketContext.switchCusRating(detailTicket.billId);
        const callback = () => ticketContext.completedTicket(detailTicket?.billId, true);
        if (!completedTicketModalRef.current) callback();
        else completedTicketModalRef.current.open(detailTicket.billId, callback);
      } else {
        loadingRef.current?.setVisible(false);
      }
    } catch (error) {
      loadingRef.current?.setVisible(false);
    }
  };

  const handleClose = () => {
    refModal.current?.reset();
    setVisible(false);
    socketContext.backToCheckIn();
  };

  return (
    <div style={{ alignSelf: 'stretch', display: 'flex' }}>
      <CashierActionButton v2UI={v2} feature='GIFT-CARD' onClick={onLoyalty} ntype='YELLOW' label='Gift Card' />
      <ModalPaymentGiftCard
        v2={v2}
        ref={refModal}
        visible={visible}
        onClose={handleClose}
        onSubmitV3={handleRedeem}
        detail={detailTicket}
        giftCardPayments={giftCardPayments}
        onDeleteItem={onDeleteItem}
        onRedeemGiftCard={handleRedeem}
        onPayment={onPayment}
        onContinueWithMultiple={onContinueWithMultiple}
        modalChooseNextPaymentRef={modalChooseNextPaymentRef}
      />
      <PaymentLoading ref={loadingRef} />
      <ConfirmTipTicket ref={completedTicketModalRef} />
      {contextCheckValidPoint}
    </div>
  );
};

export default ButtonGiftCard;
